import { render, staticRenderFns } from "./BupaSso.vue?vue&type=template&id=4b7b70e2"
import script from "./BupaSso.vue?vue&type=script&lang=js"
export * from "./BupaSso.vue?vue&type=script&lang=js"
import style0 from "./BupaSso.vue?vue&type=style&index=0&id=4b7b70e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports